// extracted by mini-css-extract-plugin
module.exports = {"root":"MarketDescription_root__0B5Lt","button":"MarketDescription_button__J00Vq","tooltipContent":"MarketDescription_tooltipContent__jhX5c"};